import { ArrowRight, MessageCircle } from "lucide-react";
import { site, waLink } from "@/config/site";
import { heroImage as heroImg, stats } from "@/data/content";

export function Hero() {
  return (
    <section id="home" className="relative min-h-[100svh] flex items-center overflow-hidden" data-testid="hero">
      {/* Background image + navy overlay */}
      <img
        src={heroImg}
        alt="Premium branded corporate office lobby by BNZ Solutions in Bengaluru"
        className="absolute inset-0 h-full w-full object-cover"
        loading="eager"
        fetchPriority="high"
      />
      <div className="absolute inset-0 bg-navy/80" />
      <div className="absolute inset-0 bg-gradient-to-r from-navy-dark/90 via-navy/60 to-transparent" />

      <div className="relative z-10 mx-auto w-full max-w-7xl px-6 md:px-8 pt-28 pb-16">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold uppercase tracking-[0.25em] text-gold-light" data-testid="hero-eyebrow">
            {site.positioning}
          </span>
          <div className="gold-rule my-6" />
          <h1 className="font-heading text-4xl sm:text-5xl lg:text-7xl font-bold leading-[1.05] text-white">
            Transforming Workspaces.
            <span className="block text-gold">Elevating Brands.</span>
          </h1>
          <p className="mt-6 max-w-xl text-base md:text-lg leading-relaxed text-white/75">
            Office Branding · Signage · Commercial Printing · Corporate Identity.
            Premium end-to-end branding solutions for businesses across Bengaluru &amp; Karnataka.
          </p>

          <div className="mt-10 flex flex-col sm:flex-row gap-4">
            <a
              href="#contact"
              data-testid="hero-cta-quote"
              className="group inline-flex items-center justify-center gap-2 bg-gold px-8 py-4 text-sm font-semibold text-navy transition-colors duration-200 hover:bg-gold-light"
            >
              Get a Free Quote
              <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
            </a>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="hero-cta-whatsapp"
              className="inline-flex items-center justify-center gap-2 border border-white/30 px-8 py-4 text-sm font-semibold text-white transition-colors duration-200 hover:border-gold hover:text-gold"
            >
              <MessageCircle className="h-4 w-4" /> WhatsApp Us
            </a>
          </div>

          {/* Stats */}
          <div className="mt-16 grid grid-cols-2 sm:grid-cols-4 gap-8 border-t border-white/15 pt-8">
            {stats.map((s) => (
              <div key={s.label} data-testid={`hero-stat-${s.label.replace(/\s+/g, "-").toLowerCase()}`}>
                <div className="font-heading text-3xl md:text-4xl font-bold text-gold">{s.value}</div>
                <div className="mt-1 text-xs md:text-sm text-white/60">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
